<template>
  <wizard-form v-on="$listeners" v-bind="$attrs">
    <template #content>
      <v-row dense>
        <v-col cols="12">
          <h1 class="primary--text font-weight-medium">
            {{ $t('transfer_summary') }}
          </h1>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-list dense>
            <v-divider class="silver" />
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_request_operation_type') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ transferType }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              class="silver"
              v-if="securityTransfer.transferType !== 'Receive'"
            />
            <v-list-item
              class="pl-0"
              v-if="securityTransfer.transferType !== 'Receive'"
            >
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_name') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ securityTransfer.beneficiaryName }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_title_transfer_financial_institution') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ $t(securityTransfer.financialInstitution) }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_index_account') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ $t(securityTransfer.accountNumber) }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
            <v-list-item class="pl-0">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('general_securities') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      <span>{{ securitiesName }}</span>
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="silver" />
            <v-list-item class="pl-0 item-text primary--text">
              <v-list-item-content>
                <v-row>
                  <v-col cols="12" sm="3" class="d-flex align-center">
                    <v-list-item-title
                      class="item-text primary--text text-body-1"
                    >
                      {{ $t('transfer_observations') }}
                    </v-list-item-title>
                  </v-col>
                  <v-col cols="12" sm="9" class="d-flex align-center">
                    <v-icon
                      class="mr-sm-5 d-none d-sm-flex"
                      v-text="'mdi-chevron-right'"
                      color="primary"
                    />
                    <v-list-item-subtitle
                      class="ml-sm-5 item-text primary--text text-body-1"
                    >
                      {{ securityTransfer.observations }}
                    </v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <ValidationProvider
            :name="$t('transfer_accordance_title')"
            :rules="{ required: { allowFalse: false } }"
            v-slot="{ errors }"
          >
            <v-checkbox
              v-model="accordance"
              class="py-0"
              :error-messages="errors[0]"
            >
              <template v-slot:label>
                <div class="agreement-text text-body-1">
                  <span>{{ $t('security_transfer_accordance_title') }}: </span>
                  <span>{{ $t('security_transfer_accordance_authorization') }}</span>
                  <br />
                  <span>{{ $t('security_transfer_accordance_agreement') }}</span>
                </div>
              </template>
            </v-checkbox>
          </ValidationProvider>
        </v-col>
      </v-row>
    </template>
  </wizard-form>
</template>
<script>
import WizardForm from '@/components/commons/WizardForm'
export default {
  components: {
    WizardForm
  },
  props: {
    securityTransfer: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      accordance: false
    }
  },
  computed: {
    securitiesName() {
      return this.securityTransfer.securities.map(item => item.name).join(', ')
    },
    transferType() {
      switch (this.securityTransfer.transferType) {
        case 'Internal':
          return this.$t('internal_security')
        case 'Send':
          return this.$t('send_security')
        default:
          return this.$t('receive_security')
      }
    }
  }
}
</script>
<style lang="sass" scoped>
.agreement-text
  color: #B0B0B2

.main-container
  line-height: normal

.item-text
  font-size: 1.143rem

hr
  margin: 0
  padding: 0

hr.rounded
  border-top: 2px solid
  width: 250px
</style>
